import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './task-simple.types';
import * as constants from './task-simple.constants';

export const taskSimpleReducer = generateResourceReducer<types.ITaskSimple>({
  STORE: constants.STORE_TASK_SIMPLE,
  CLEAR: constants.CLEAR_TASK_SIMPLE,
});
